/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {AddressbarColor,Notify,Dialog,Cookies} from 'quasar'



export default { config: {"brand":{"primary":"#edb20c","accent":"#6b2d5c","positive":"#5bba6f","negative":"#e94f37","info":"#a3d9ff"}},plugins: {AddressbarColor,Notify,Dialog,Cookies} }

